import { render, staticRenderFns } from "./EditIncome.vue?vue&type=template&id=f32b0398&"
import script from "./EditIncome.vue?vue&type=script&lang=js&"
export * from "./EditIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports